import { useEffect, useState } from "react";
import { P, pub } from "@/lib/publicApi";
import { ScrollText, ShieldCheck, ChevronDown, Download, QrCode } from "lucide-react";

export default function PoliciesRights() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState("rights_accessibility");
  useEffect(() => { pub.get("/policies").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-center text-sm py-10" style={{ color: P.dim }}>Loading policies…</div>;
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <h2 className="text-2xl font-bold" style={{ color: P.navy }}>Policies &amp; Accountability</h2>
        <p className="text-sm mt-1" style={{ color: P.dim }}>{data.note}</p>
        <div className="flex flex-wrap gap-2 mt-3">
          <a data-testid="sop-manual-download" href={`${pub.defaults.baseURL}/sop-manual.pdf`} target="_blank" rel="noreferrer"
            className="flex items-center gap-2 px-4 py-2.5 text-sm font-bold text-white rounded-sm hover:opacity-90" style={{ background: P.navy }}>
            <Download size={15} /> FULL SOP MANUAL (PDF)
          </a>
          <a data-testid="qr-poster-download" href={`${pub.defaults.baseURL}/qr-poster.pdf`} target="_blank" rel="noreferrer"
            className="flex items-center gap-2 px-4 py-2.5 text-sm font-bold text-white rounded-sm hover:opacity-90" style={{ background: P.gold }}>
            <QrCode size={15} /> PRINTABLE QR POSTER
          </a>
        </div>
      </div>
      <div data-testid="bill-of-rights" className="border-2 rounded-sm overflow-hidden" style={{ borderColor: P.navy, background: "#fff" }}>
        <div className="px-5 py-3 flex items-center gap-2" style={{ background: P.navy }}>
          <ShieldCheck size={18} style={{ color: P.gold }} />
          <div className="text-white font-bold text-sm">PUBLIC BILL OF RIGHTS — When interacting with MATCOM, you have the right to:</div>
        </div>
        <ol className="p-5 space-y-2 list-decimal list-inside">
          {data.bill_of_rights.map((r, i) => (
            <li key={i} data-testid={`right-${i}`} className="text-sm leading-relaxed" style={{ color: P.ink }}>{r}</li>
          ))}
        </ol>
      </div>
      <div className="space-y-2">
        {data.categories.map((cat) => (
          <div key={cat.key} className="border rounded-sm bg-white" style={{ borderColor: P.line }}>
            <button data-testid={`policy-cat-${cat.key}`} onClick={() => setOpen(open === cat.key ? "" : cat.key)}
              className="w-full flex items-center gap-2 px-4 py-3 text-left">
              <ScrollText size={16} style={{ color: P.gold }} />
              <span className="font-bold text-sm" style={{ color: P.navy }}>{cat.name}</span>
              <span className="text-xs" style={{ color: P.dim }}>({cat.sops.length} SOPs{cat.includes_bill_of_rights ? " + Bill of Rights" : ""})</span>
              <ChevronDown size={15} className="ml-auto transition-transform" style={{ color: P.dim, transform: open === cat.key ? "rotate(180deg)" : "none" }} />
            </button>
            {open === cat.key && (
              <div className="px-4 pb-4 grid sm:grid-cols-2 gap-1.5">
                {cat.sops.map((s) => (
                  <a key={s.code} data-testid={`sop-${s.code}`} href={`${pub.defaults.baseURL}/sop-manual.pdf`} target="_blank" rel="noreferrer"
                    className="flex items-start gap-2 p-2 rounded-sm text-sm hover:opacity-80" style={{ background: "#F1EFE8" }}>
                    <span className="font-mono text-[10px] font-bold px-1.5 py-0.5 rounded-sm shrink-0 text-white" style={{ background: P.navy }}>{s.code}</span>
                    <span style={{ color: P.ink }}>{s.title}</span>
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
